export default class Deselect extends CustomEvent {
    constructor(caller) {
        super('deselect', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
